module.exports = __webpack_public_path__ + "img/norway-endocrine-nutritional-metabolic-diseases-male.6075cd9f.png";